import React from "react";
import { connect } from 'react-redux';
import TextInput from '@zacousticrepo/grommet-v1-custom/components/TextInput';

class MinMaxSelectorFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            min: undefined,
            max: undefined
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeAndFilter = this.closeAndFilter.bind(this);
        this.updateMin = this.updateMin.bind(this);
        this.updateMax = this.updateMax.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    closeAndFilter() {
        const
            {
                onClose
            } = this.props;
        onClose(this.state.min, this.state.max);
    }

    updateMin({ target }) {
        const min = parseInt(target.value);
        if (!isNaN(min)) {
            this.setState({ min: min });
        }
    }

    updateMax({ target }) {
        const max = parseInt(target.value);
        if (!isNaN(max)) {
            this.setState({ max: max });
        }
    }

    render() {
        const
            {
                title
            } = this.props;
        let textInput;
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-min-max-selector-filter" ref={this.wrapperRef}>
                <div className="eighteen-regular" >
                    {title}
                </div>
                <div className="flex-container" style={{ margin: '20px auto' }}>
                    <div className="eighteen-regular" style={{ margin: 'auto 14px auto 0' }}>Min</div>
                    <TextInput
                        className="rectangle-28965"
                        id={"1"}
                        name={"min"}
                        onDOMChange={this.updateMin}
                        value={textInput}
                    />
                </div>
                <div className="flex-container" style={{ margin: '20px auto' }}>
                    <div className="eighteen-regular" style={{ margin: 'auto 10px auto 0' }}>Max</div>
                    <TextInput
                        className="rectangle-28965"
                        id={"2"}
                        name={"max"}
                        onDOMChange={this.updateMax}
                        value={textInput}
                    />
                </div>
                <div style={{ position: 'relative' }}>
                    <button className="main-button-01" style={{ position: 'relative', margin: '0 auto' }}
                        onClick={this.closeAndFilter}>Filter</button>
                </div>
            </div>
        </div>);
    };
}

const select = state => ({});

export default connect(select)(MinMaxSelectorFilter);

